import React, { useState} from "react";


const SidebarContext = React.createContext({
    sidebar: false,
    toggleSidebar: () => {},
    });


export function SidebarContextProvider (props) {
    const [sidebar, setSidebar] = useState(false);

    function toggleSidebar() {
        setSidebar((prevState) => !prevState);
        console.log("toggleSidebar, now: " + sidebar);
    }

    const contextValue = {
        sidebar: sidebar,
        toggleSidebar: toggleSidebar,
    };
    return (
        <SidebarContext.Provider value={contextValue}>
            {props.children}
        </SidebarContext.Provider>
    );
}

export default SidebarContext;